import React, { createContext, useContext, useState, useCallback } from 'react';

const CopilotContext = createContext({
  open: false,
  toggle: () => {},
  openPanel: () => {},
  closePanel: () => {},
});

export function CopilotProvider({ children }) {
  const [open, setOpen] = useState(false);

  const openPanel = useCallback(() => setOpen(true), []);
  const closePanel = useCallback(() => setOpen(false), []);
  const toggle = useCallback(() => setOpen((prev) => !prev), []);

  return (
    <CopilotContext.Provider value={{ open, toggle, openPanel, closePanel }}>
      {children}
    </CopilotContext.Provider>
  );
}

export function useCopilotContext() {
  return useContext(CopilotContext);
}
